module.exports = __webpack_public_path__ + "static/the-little-drummer-girl-8f18c6ac02a94c975fa92187c7f1fb36.jpg";